import React from 'react';
import { usePage } from "@inertiajs/react";
import SelectMulti from "@/User/Components/SelectMulti";

const ThemeSelect = ({ id, values, handleChange }) => {
    const { themeList } = usePage().props;

    return (
        <SelectMulti id={id} options={themeList} value={values} handleChange={handleChange} placeholder="テーマを選ぶ" />
    );
};

export default ThemeSelect;
